export default __webpack_public_path__ + "static/northqld-b92c9996d9ec4ffc6a78d63b92172112.jpg";